module.exports = __webpack_public_path__ + "static/media/landing-poster.93314fd1.jpg";